import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { League } from "../client/api";
import { AppDispatch, RootState } from "../store";
import { selectUserValue } from "../selectors";
import { isPremium } from "../config/utils";
import { addFavorite, removeFavorite } from "../store/actions/userActions";

export function useLeagueBaseData(leagueId?: number) {
    const dispatch = useDispatch<AppDispatch>();
    const league = useSelector(
        (s: RootState) => s.leagues.value.find((x: League) => String(x.id) === String(leagueId)) || null
    );
    const allLeagues = useSelector((s: RootState) => s.leagues.value);
    const favorites = useSelector((state: RootState) => state.user.favorites);
    const user = useSelector(selectUserValue);
    const aoi = user?.areaOfInterest?.id || -1;
    const isPremiumUser = isPremium(user);

    const isCup = useMemo(() => league?.subCategory?.isCup || false, [league?.subCategory?.isCup]);

    const isRestrictedAreaOfInterest = useMemo(
        () =>
            (league?.areasOfInterest || []).some(
                (aoiItem) => aoiItem?.id === 1 || aoiItem?.id === 2
            ),
        [league?.areasOfInterest]
    );

    const hasTotwRestriction = isRestrictedAreaOfInterest && !isPremiumUser;

    const isFollowing = useMemo(
        () => favorites.some((fav) => fav.type === "league" && fav.id === leagueId),
        [favorites, leagueId]
    );

    const handleFollowToggle = useCallback(() => {
        if (!user || !leagueId) return;

        if (isFollowing) {
            removeFavorite(dispatch, { id: leagueId, type: "league" });
        } else {
            addFavorite(dispatch, { id: leagueId, type: "league" });
        }
    }, [user, leagueId, isFollowing, dispatch]);

    return {
        league,
        allLeagues,
        user,
        aoi,
        isCup,
        hasTotwRestriction,
        isFollowing,
        handleFollowToggle,
    };
}

